<template>
  <div>
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-divider class="my-5"></v-divider>

    <v-card flat class="pa-4 mt-4">
      <br />

      <!-- SYLLABUS COMPLETION (lazy) -->
      <lazy-observer :onVisible="getAcademicsSyllabusCompletionRatio">
        <template v-slot:default>
          <div v-if="loadingsyllabusCompletion">
            <v-skeleton-loader type="list-item-three-line,image"></v-skeleton-loader>
          </div>
          <div v-else>
            <!-- <chart
              v-if="syllabus_completion_graph && syllabus_completion_graph.series && syllabus_completion_graph.series.length"
              class="chart" auto-resize :options="syllabus_completion_graph" style="height: 600px;"></chart>
            <div v-else class="text-center pa-4">No data found</div> -->
            <div
  v-if="syllabus_completion_graph && syllabus_completion_graph.series && syllabus_completion_graph.series.length"
  class="topic-scrollable-container"
>
  <div
    :style="{
      width: '100%',
      maxWidth: '1400px',
      height: Math.max(450, syllabusClassCount * 32) + 'px',
      margin: '0 auto'
    }"
  >
    <chart
      class="topic-chart-inner"
      auto-resize
      :options="syllabus_completion_graph"
      style="width: 100%; height: 100%;"
    />
  </div>
</div>

<div v-else class="text-center pa-4">No data found</div>

          </div>
        </template>
      </lazy-observer>

      <v-divider class="my-5"></v-divider>
      <!-- TOPIC GRAPH (lazy) -->
      <lazy-observer
  :key="filterKey + '-topic'"
  :onVisible="getAcademicsTopicGraph"
>
        <template v-slot:default>
          <div v-if="loadingTopicGraph">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </div>
          <div v-else>
            <div v-if="topic_ratio_chart.series && topic_ratio_chart.series.length" class="topic-scrollable-container">

              <!-- Dynamic height based on number of classes -->
              <div :style="{
                width: '100%',
                maxWidth: '1400px',
                height: Math.max(450, filteredClassCount * 32) + 'px',
                margin: '0 auto'
              }">
                <chart class="topic-chart-inner" auto-resize :options="topic_ratio_chart"
                  style="width: 100%; height: 100%;"></chart>
              </div>

            </div>
            <div v-else class="text-center pa-4">No data found</div>
          </div>
        </template>
      </lazy-observer>
      <v-divider class="my-5"></v-divider>

      <!-- ATTENDANCE GRAPH (lazy) -->
      <lazy-observer :onVisible="getAcademicsAttendanceGraph">
        <template v-slot:default>
          <div v-if="loadingAttendanceGraph">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </div>
          <div v-else>
            <div v-if="attendance_ratio_chart.series && attendance_ratio_chart.series.length"
              class="topic-scrollable-container">
              <div :style="{
                width: '100%',
                maxWidth: '1400px',
                height: Math.max(450, filteredAttendanceClassCount * 32) + 'px',
                margin: '0 auto'
              }">
                <chart class="topic-chart-inner" auto-resize :options="attendance_ratio_chart"
                  style="width: 100%; height: 100%;"></chart>
              </div>
            </div>
            <div v-else class="text-center pa-4">No data found</div>
          </div>
        </template>
      </lazy-observer>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AcademicsDashboard",
  props: ["selected_ay", "selected_standard", "selected_div"],

  data() {
    return {
      snackbar: false,
      color: "",
      snackbar_msg: "",

      // loading flags (per-section)
      loadingsyllabusCompletion: false,
      loadingTopicGraph: false,
      loadingAttendanceGraph: false,

      // generic small flag (not used to trigger APIs)
      loading: false,

      // caches for API results per filter key
      cache: {
        syllabus: {},
        topic: {},
        attendance: {},
      },

      // Chart option objects (initial defaults)
      syllabus_completion_graph: {
        title: { text: "Syllabus Completion %", left: "center" },
        tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
        grid: { top: 60, bottom: 80 },
        xAxis: { type: "category", data: [], axisLabel: { rotate: 0 }, name: "Grade", nameLocation: "middle", nameGap: 40 },
        yAxis: { type: "value", name: "Completion %", nameLocation: "middle", nameGap: 45 },
        series: []
      },

      topic_ratio_chart: {
        title: { text: "Topic Planned Vs Topic Covered", left: "center" },
        color: [
          { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#fcf6bd' }, { offset: 1, color: '#fee440' }] },
          { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#a9def9' }, { offset: 1, color: '#00bbf9' }] }
        ],
        tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
        grid: { top: 60, bottom: 80 },
        legend: { data: [], top: "bottom" },
        xAxis: { type: "category", name: ["Class"], data: [], axisLabel: { rotate: 0 }, nameLocation: "middle", nameGap: 40 },
        yAxis: { type: "value", name: "Progress %", nameLocation: "middle", nameGap: 45 },
        series: []
      },

      attendance_ratio_chart: {
        title: { text: "Class Wise Attendance %", left: "center" },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: params => `<strong>${params[0].name}</strong><br/>Attendance: <b>${params[0].value}%</b>`
        },
        grid: {
          left: "15%",
          right: "10%",
          top: 80,
          bottom: 80,
          containLabel: true
        },
        xAxis: {
          type: "value",
          name: "Attendance %",
          nameLocation: "middle",
          nameGap: 50,
          min: 0,
          max: 100,
          axisLabel: { formatter: "{value}%" }
        },
        yAxis: {
          type: "category",
          inverse: true,  // Highest class at top
          name: "Class / Division",
          nameLocation: "middle",
          nameGap: 140,
          data: [],
          axisLabel: {
            interval: 0,
            width: 260,
            overflow: "truncate",
            ellipsis: "...",
            align: "right",
            formatter: v => v.length > 25 ? v.replace(/(.{20})(.+)/, "$1\n$2") : v
          }
        },
        series: []
      },
    };
  },

  computed: {
    // unique key for caching per filter combination
    filterKey() {
      return `${this.selected_ay || ""}|${this.selected_standard || ""}|${this.selected_div || ""}`;
    },
    syllabusClassCount() {
    if (
      this.syllabus_completion_graph &&
      this.syllabus_completion_graph.yAxis &&
      this.syllabus_completion_graph.yAxis.data
    ) {
      return this.syllabus_completion_graph.yAxis.data.length;
    }
    return 0;
  },
    filteredClassCount() {
      // Safely get the number of classes from the current chart data
      if (this.topic_ratio_chart && this.topic_ratio_chart.yAxis && this.topic_ratio_chart.yAxis.data) {
        return this.topic_ratio_chart.yAxis.data.length;
      }
      return 0;
    },
    filteredAttendanceClassCount() {
      if (this.attendance_ratio_chart && this.attendance_ratio_chart.yAxis && this.attendance_ratio_chart.yAxis.data) {
        return this.attendance_ratio_chart.yAxis.data.length;
      }
      return 0;
    }
  },

  watch: {
    selected_ay() { this.onFilterChange(); },
    selected_standard() { this.onFilterChange(); },
    selected_div() { this.onFilterChange(); },
  },

  created() {
    // local registration of LazyObserver component
    this.$options.components.LazyObserver = {
      name: "LazyObserver",
      props: {
        onVisible: { type: Function, required: true }
      },
      data() {
        return { loaded: false, observer: null };
      },
      mounted() {
        // Use IntersectionObserver to trigger onVisible once visible
        try {
          this.observer = new IntersectionObserver(
            (entries) => {
              const e = entries && entries[0];
              if (e && e.isIntersecting && !this.loaded) {
                this.loaded = true;
                // call callback (safely)
                try { this.onVisible(); } catch (err) { /* ignore callback errors */ }
                if (this.observer) {
                  this.observer.disconnect();
                  this.observer = null;
                }
              }
            },
            { threshold: 0.15 }
          );
          this.observer.observe(this.$el);
        } catch (err) {
          // fallback: if IntersectionObserver is not available, load immediately
          this.loaded = true;
          try { this.onVisible(); } catch (e) {}
        }
      },
      beforeDestroy() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      },
      render(h) {
        // When loaded: render slot content
        if (this.loaded) {
          return this.$slots.default ? this.$slots.default[0] : h("div");
        }
        // Not loaded yet: render the default slot fallback if provided, otherwise a skeleton
        if (this.$scopedSlots.default) {
          // return the fallback skeleton provided by parent via default slot content
          return this.$scopedSlots.default();
        }
        // fallback skeleton
        return h("div", [h("v-skeleton-loader", { props: { type: "image" } })]);
      }
    };
  },

  methods: {
    showSnackbar(color, msg) {
      this.color = color;
      this.snackbar_msg = msg;
      this.snackbar = true;
    },

    onFilterChange() {
      // clear charts and caches — lazy observers will re-fetch when scrolled into view
      this.clearCharts();
      this.clearCaches();
      // optionally scroll to top so user can re-trigger top lazy section if desired
      // window.scrollTo(0,0);
    },

    clearCaches() {
      this.cache = { syllabus: {}, topic: {}, attendance: {} };
    },

    clearCharts() {
      // reset each chart to empty state
      this.syllabus_completion_graph = {
        title: { text: "Syllabus Completion %", left: "center" },
        tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
        grid: { top: 60, bottom: 80 },
        xAxis: { type: "category", data: [], axisLabel: { rotate: 0 }, name: "Grade", nameLocation: "middle", nameGap: 40 },
        yAxis: { type: "value", name: "Completion %", nameLocation: "middle", nameGap: 45 },
        series: []
      };

      this.topic_ratio_chart.xAxis.data = [];
      this.topic_ratio_chart.series = [];
      this.topic_ratio_chart.legend.data = [];

      this.attendance_ratio_chart.xAxis.data = [];
      this.attendance_ratio_chart.series = [];
      this.attendance_ratio_chart.legend.data = [];
    },

    // cache helpers
    getCache(sectionKey) {
      return this.cache && this.cache[sectionKey] && this.cache[sectionKey][this.filterKey];
    },
    setCache(sectionKey, value) {
      if (!this.cache) this.cache = {};
      if (!this.cache[sectionKey]) this.$set(this.cache, sectionKey, {});
      this.$set(this.cache[sectionKey], this.filterKey, value);
    },

    // -------------------- API calls (lazy + cached) --------------------
    async getAcademicsSyllabusCompletionRatio() {
      const section = "syllabus";
      const cached = this.getCache(section);
      if (cached) {
        this.syllabus_completion_graph = cached.chart;
        return;
      }

      this.loadingsyllabusCompletion = true;
      try {
        const res = await axios.post(
          "/AdminDashboard/getAcademicsSyllabusCompletionRatio",
          {
            selected_ay: this.selected_ay,
            selected_standard: this.selected_standard,
            selected_div: this.selected_div,
          }
        );

        if (
          res.data.flag === "YES" &&
          Array.isArray(res.data.dataSyllabusCompletionRatio)
        ) {
          // ✅ Show ONLY rows with meaningful value
          const filteredData = res.data.dataSyllabusCompletionRatio.filter(item => {
            const perc = Number(item.percentage) || 0;
            return perc > 0;
          });

          if (!filteredData.length) {
            this.syllabus_completion_graph = {
              ...this.syllabus_completion_graph,
              yAxis: { data: [] },
              series: []
            };
            this.setCache(section, { chart: this.syllabus_completion_graph });
            return;
          }

          const classes = filteredData.map(
            item => `${item.standard}-${item.division}`
          );

          const percentages = filteredData.map(item =>
            parseFloat(Number(item.percentage).toFixed(2))
          );

          // 🔥 AUTO BAR SIZE BASED ON DATA COUNT (KEY CHANGE)
          const rowCount = classes.length;

          const barWidth =
            rowCount <= 5 ? 22 :
              rowCount <= 10 ? 16 :
                rowCount <= 20 ? 12 :
                  rowCount <= 30 ? 9 : 7;

          const chart = {
            title: { text: "Syllabus Completion %", left: "center" },
            tooltip: {
              trigger: "axis",
              axisPointer: { type: "shadow" },
              formatter: p =>
                `<strong>${p[0].name}</strong><br/>Completion: <b>${p[0].value}%</b>`
            },
            grid: {
              left: "15%",
              right: "10%",
              top: 80,
              bottom: 80,
              containLabel: true
            },
            xAxis: {
              type: "value",
              min: 0,
              max: 100,
              name: "Completion %",
              nameLocation: "middle",
              nameGap: 50,
              axisLabel: { formatter: "{value}%" }
            },
            yAxis: {
              type: "category",
              inverse: true,
              name: "Class / Division",
              nameLocation: "middle",
              nameGap: 140,
              data: classes,
              axisLabel: {
                interval: 0,
                width: 260,
                overflow: "truncate",
                ellipsis: "...",
                formatter: v =>
                  v.length > 25 ? v.replace(/(.{20})(.+)/, "$1\n$2") : v
              }
            },
            series: [
              {
                name: "Completion %",
                type: "bar",
                barWidth: barWidth,          // ✅ dynamic
                barCategoryGap: "20%",       // ✅ tight spacing
                data: percentages,
                label: {
                  show: true,
                  position: "right",
                  formatter: "{c}%"
                },
                itemStyle: {
                  borderRadius: [0, 8, 8, 0],
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      { offset: 0, color: "#ffb84d" },
                      { offset: 1, color: "#ff8c00" }
                    ]
                  }
                }
              }
            ]
          };

          this.syllabus_completion_graph = chart;
          this.setCache(section, { chart });
        }
      } catch (err) {
        console.error("Error getAcademicsSyllabusCompletionRatio:", err);
        this.showSnackbar("error", "Failed to load syllabus completion data");
      } finally {
        this.loadingsyllabusCompletion = false;
      }
    },
   
async getAcademicsTopicGraph() {
  const section = "topic";
  const cached = this.getCache(section);
  if (cached) {
    this.topic_ratio_chart = cached.chartOptions;
    return;
  }

  this.loadingTopicGraph = true;

  try {
    const res = await axios.post("/AdminDashboard/getAcademicsTopicGraph", {
      selected_ay: this.selected_ay,
      selected_standard: this.selected_standard,
      selected_div: this.selected_div,
    });

    if (
      res.data.flag === "YES" &&
      Array.isArray(res.data.topicGraphList) &&
      res.data.topicGraphList.length > 0
    ) {

      const filteredData = res.data.topicGraphList.filter(item => {
        return (Number(item.planned) || 0) > 0 || (Number(item.covered) || 0) > 0;
      });

      if (!filteredData.length) {
        this.topic_ratio_chart.series = [];
        this.topic_ratio_chart.yAxis.data = [];
        this.setCache(section, { chartOptions: this.topic_ratio_chart });
        return;
      }

      filteredData.sort((a, b) => {
        const sa = parseInt(a.standard);
        const sb = parseInt(b.standard);
        if (sa !== sb) return sa - sb;
        return a.division.localeCompare(b.division);
      });

      const classes = [];
      const plannedData = [];
      const coveredData = [];

      filteredData.forEach(item => {
        classes.push(`${item.standard}-${item.division}`);
        plannedData.push(Number(item.planned) || 0);
        coveredData.push(Number(item.covered) || 0);
      });

      const chartOptions = {
        title: {
          text: "Topic Planned Vs Topic Covered",
          left: "center",
          textStyle: { fontSize: 16, fontWeight: "bold" }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" }
        },
        legend: {
          data: ["Planned", "Covered"],
          bottom: 10
        },
        grid: {
          left: "18%",
          right: "5%",
          top: 80,
          bottom: 100,
          containLabel: true
        },
        xAxis: {
          type: "value",
          name: "Number of Topics",
          nameLocation: "middle",
          nameGap: 50,
          min: 0
        },
        yAxis: {
          type: "category",
          inverse: true,
          name: "Class / Division",
          nameLocation: "middle",
          nameGap: 140,
          data: classes,
          axisLabel: {
            interval: 0,
            width: 280,
            overflow: "truncate",
            ellipsis: "...",
            align: "right"
          }
        },
        series: [
          {
            name: "Planned",
            type: "bar",
            barWidth: 10,
            barGap: "50%",
            barCategoryGap: "100%",
            data: plannedData,
            itemStyle: {
              color: {
                type: "linear",
                x: 0, y: 0, x2: 1, y2: 0,
                colorStops: [
                  { offset: 0, color: "#f0f9c0" },
                  { offset: 1, color: "#b0d65a" }
                ]
              },
              borderRadius: [0, 8, 8, 0]
            },
            label: {
              show: true,
              position: "right",
              fontWeight: "bold"
            }
          },
          {
            name: "Covered",
            type: "bar",
            barWidth: 10,
            barGap: "50%",
            barCategoryGap: "100%",
            data: coveredData,
            itemStyle: {
              color: {
                type: "linear",
                x: 0, y: 0, x2: 1, y2: 0,
                colorStops: [
                  { offset: 0, color: "#c0e8f9" },
                  { offset: 1, color: "#4da6ff" }
                ]
              },
              borderRadius: [0, 8, 8, 0]
            },
            label: {
              show: true,
              position: "right",
              fontWeight: "bold"
            }
          }
        ]
      };

      this.topic_ratio_chart = chartOptions;
      this.setCache(section, { chartOptions });
    } else {
      this.topic_ratio_chart.series = [];
      this.topic_ratio_chart.yAxis.data = [];
    }

  } catch (err) {
    console.error("Error getAcademicsTopicGraph:", err);
    this.showSnackbar("error", "Failed to load topic graph data");
  } finally {
    this.loadingTopicGraph = false;
  }
},
    async getAcademicsAttendanceGraph() {
      const section = "attendance";
      const cached = this.getCache(section);
      if (cached) {
        this.attendance_ratio_chart = cached.chartOptions;
        return;
      }

      this.loadingAttendanceGraph = true;
      try {
        const res = await axios.post("/AdminDashboard/getAcademicsAttendanceGraph", {
          selected_ay: this.selected_ay,
          selected_standard: this.selected_standard,
          selected_div: this.selected_div,
        });

        if (res.data.flag === "YES" && Array.isArray(res.data.attendanceGraphList) && res.data.attendanceGraphList.length > 0) {
          // Filter only classes with attendance > 0%
          const filteredData = res.data.attendanceGraphList.filter(item => {
            const perc = Number(item.percentage) || 0;
            return perc > 0;
          });

          if (filteredData.length === 0) {
            this.attendance_ratio_chart.yAxis.data = [];
            this.attendance_ratio_chart.series = [];
            this.setCache(section, { chartOptions: this.attendance_ratio_chart });
            return;
          }

          // Sort consistently: standard then division
          filteredData.sort((a, b) => {
            if (a.standard === b.standard) return a.division.localeCompare(b.division);
            return a.standard.localeCompare(b.standard);
          });

          const classes = filteredData.map(item => `${item.standard}-${item.division}`);
          const percentages = filteredData.map(item => parseFloat(Number(item.percentage).toFixed(2)));

          const rowCount = classes.length;

          // Dynamic bar width based on number of classes (same logic as syllabus)
          const barWidth =
            rowCount <= 5 ? 22 :
              rowCount <= 10 ? 16 :
                rowCount <= 20 ? 12 :
                  rowCount <= 30 ? 9 : 7;

          const chartOptions = {
            title: { text: "Class Wise Attendance %", left: "center" },
            tooltip: {
              trigger: "axis",
              axisPointer: { type: "shadow" },
              formatter: p => `<strong>${p[0].name}</strong><br/>Attendance: <b>${p[0].value}%</b>`
            },
            grid: {
              left: "5%",
              right: "10%",
              top: 80,
              bottom: 80,
              containLabel: true
            },
            xAxis: {
              type: "value",
              name: "Attendance %",
              nameLocation: "middle",
              nameGap: 50,
              min: 0,
              max: 100,
              interval: 25,
              axisLabel: { formatter: "{value}%" }
            },
            yAxis: {
              type: "category",
              inverse: true,
              name: "Class / Division",
              nameLocation: "middle",
              nameGap: 140,
              data: classes,
              axisLabel: {
                interval: 0,
                width: 260,
                overflow: "truncate",
                ellipsis: "...",
                align: "right",
                formatter: v => v.length > 25 ? v.replace(/(.{20})(.+)/, "$1\n$2") : v
              }
            },
            series: [
              {
                name: "Attendance %",
                type: "bar",
                barWidth: barWidth,
                barCategoryGap: "20%",
                data: percentages,
                label: {
                  show: true,
                  position: "right",
                  formatter: "{c}%",
                  fontSize: 12
                },
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0, y: 0, x2: 1, y2: 0,
                    colorStops: [
                      { offset: 0, color: "#ffb3c6" },
                      { offset: 1, color: "#fd3e81" }
                    ]
                  },
                  borderRadius: [0, 8, 8, 0]
                }
              }
            ]
          };

          this.attendance_ratio_chart = chartOptions;
          this.setCache(section, { chartOptions });
        } else {
          this.attendance_ratio_chart.yAxis.data = [];
          this.attendance_ratio_chart.series = [];
        }
      } catch (err) {
        console.error("Error getAcademicsAttendanceGraph:", err);
        this.showSnackbar("error", "Failed to load attendance graph data");
      } finally {
        this.loadingAttendanceGraph = false;
      }
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  height: 900px;
  max-width: 1000px;
  margin: 0 auto;
}

.gradient-male {
  background: #bde0fe;
}

.gradient-female {
  background: #ffc8dd;
}

.text-center {
  text-align: center;
}
.topic-scrollable-container {
  height: 650px;                  /* Fixed visible area */
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  padding: 16px 0;                /* Optional: nice inner padding */
}

/* Remove or comment this out */
/*
.topic-chart-inner {
  height: 3000px;
  width: 100%;
}
*/

/* Keep the beautiful thin scrollbar */
.topic-scrollable-container::-webkit-scrollbar {
  width: 10px;
}
.topic-scrollable-container::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 10px;
}
.topic-scrollable-container::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 10px;
  border: 2px solid #f5f5f5;
}
.topic-scrollable-container::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}
.topic-scrollable-container {
  height: 650px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  padding: 16px 0;
}

</style>
